export const ALERTS_URL_PREFIX = 'alerts'

export const ALERT_COLUMN_IDS = {
  inherentRisk: 'inherentRisk',
  thirdParty: 'thirdParty',
  alert: 'alert',
  severity: 'severity',
  dateDetected: 'dateDetected',
  status: 'status',
  aiPosture: 'aiPosture',
} as const
